import { registerComponent as A } from "@aileron/icon";
import { unsafeCSS as k, LitElement as R, html as j } from "lit";
import { html as c, unsafeStatic as T } from "lit/static-html.js";
import { state as N, query as F, property as u } from "lit/decorators.js";
const P = (o) => {
  class t extends o {
    constructor(...n) {
      super(...n), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const e = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(e.getElementsByTagName("link")).findIndex(
        (l) => l.href === this.fontLink
      ) === -1) {
        const l = document.createElement("link");
        l.href = this.fontLink, l.rel = "stylesheet", document.head.appendChild(l);
      }
    }
  }
  return t;
}, G = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.static{position:static}.relative{position:relative}.mb-4{margin-bottom:1rem}.inline{display:inline}.flex{display:flex}.hidden{display:none}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}[hidden]{display:none!important}', M = k(G), v = "aileron-color-scheme", L = "aileron-color-scheme-change", I = (o) => {
  const i = class i extends o {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (e) => {
        e.detail ? this.setAttribute(v, e.detail) : this.removeAttribute(v);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        L,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const e = document.documentElement.getAttribute(
        v
      );
      e && this.setAttribute(v, e);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        L,
        this.handleSchemeSwitch
      );
    }
  };
  i.styles = [
    M,
    o.styles ?? []
  ];
  let t = i;
  return t;
}, x = I(P(R));
function _(o, t, i) {
  const n = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...i
  });
  return o.dispatchEvent(n), n;
}
const $ = `
  a[href], area[href], input:not([disabled]):not([tabindex='-1']),
  button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),
  textarea:not([disabled]):not([tabindex='-1']),
  iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true],
  .adc-accordion-item,
  .adc-button,
  .adc-checkbox,
  .adc-content-switch,
  .adc-datepicker-input,
  .adc-input,
  .adc-link,
  .adc-modal,
  .adc-modal-close-button,
  .adc-notification,
  .adc-radio-button,
  .adc-search,
  .adc-tab,
  .adc-textarea
`, z = (o) => class extends o {
  focus() {
    var t, i;
    if ((t = this.shadowRoot) != null && t.delegatesFocus)
      super.focus();
    else {
      const n = ((i = this.shadowRoot) == null ? void 0 : i.querySelector($)) || this.querySelector($);
      n ? n.focus() : super.focus();
    }
  }
};
function V(o, ...t) {
  return o.addEventListener(...t), {
    release() {
      return o.removeEventListener(...t), null;
    }
  };
}
const q = /^((document|window|parentRoot|shadowRoot):)?([\w-]+)$/;
function D(o) {
  const i = class i extends o {
    constructor(...e) {
      super(...e), this._handles = /* @__PURE__ */ new Set();
    }
    connectedCallback() {
      super.connectedCallback();
      const e = this.constructor._hostListeners;
      Object.keys(e).forEach((a) => {
        Object.keys(e[a]).forEach((s) => {
          const l = q.exec(s);
          if (!l)
            throw new Error(`Could not parse the event name: ${a}`);
          const [, , b, g] = l, B = {
            document: this.ownerDocument,
            window: this.ownerDocument.defaultView,
            parentRoot: this.getRootNode(),
            shadowRoot: this.shadowRoot
          }[b] || this, { options: U } = e[a][s];
          this._handles.add(
            V(
              B,
              this.constructor[g] ?? g,
              this[a],
              U
            )
          );
        });
      });
    }
    disconnectedCallback() {
      this._handles.forEach((e) => {
        e.release(), this._handles.delete(e);
      }), super.disconnectedCallback();
    }
  };
  i._hostListeners = {};
  let t = i;
  return t;
}
const H = j`<svg
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M43.3422 72.6212C47.8333 80.1498 55.008 79.9998 56.9207 79.9998H80.0001L52.7659 46.2927C40.2033 46.8213 33.5541 55.0356 34.9204 58.4784L43.3422 72.6212Z"
    fill="url(#paint0_linear_13722_43684)"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M34.9203 58.4783C34.4332 57.2676 34.1787 55.9727 34.1707 54.6641C34.1707 46.9712 40.8618 42.5641 48.4709 40.9713L52.7659 46.2927C40.2032 46.8212 33.5541 55.0355 34.9203 58.4783Z"
    fill="url(#paint1_linear_13722_43684)"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M45.4231 33.4642C33.9395 33.4642 25.3706 35.3928 25.3706 39.9714C25.3706 41.6571 25.8821 43.1214 27.2904 45.6856L34.9204 58.4713C34.4333 57.2605 34.1788 55.9657 34.1707 54.657C34.1707 46.9642 40.8619 42.5571 48.471 40.9642C50.6696 40.4961 52.9091 40.2568 55.1551 40.2499C56.8275 40.1697 58.5013 40.3725 60.1087 40.8499C59.317 37.9356 57.2221 33.4642 45.4231 33.4642Z"
    fill="url(#paint2_linear_13722_43684)"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.2181 25.4856C18.378 30.7642 19.5481 32.0785 27.059 32.0856H41.4013L21.622 6.59998C17.257 1.09285 14.7346 0.085714 10.7269 0H0L15.2181 25.4856Z"
    fill="url(#paint3_linear_13722_43684)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_13722_43684"
      x1="22.4998"
      y1="45.3999"
      x2="22.4998"
      y2="97.3426"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#ED1C24" />
      <stop offset="0.13" stop-color="#E81B23" />
      <stop offset="0.27" stop-color="#DB1A21" />
      <stop offset="0.42" stop-color="#C4171D" />
      <stop offset="0.58" stop-color="#A41317" />
      <stop offset="0.74" stop-color="#7B0E10" />
      <stop offset="0.75" stop-color="#780E0F" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_13722_43684"
      x1="34.1707"
      y1="58.4819"
      x2="52.7659"
      y2="58.4819"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#69231D" />
      <stop offset="0.26" stop-color="#8D2922" />
      <stop offset="0.58" stop-color="#B22F26" />
      <stop offset="0.84" stop-color="#C93329" />
      <stop offset="1" stop-color="#D1342A" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_13722_43684"
      x1="40.9479"
      y1="54.4143"
      x2="55.8475"
      y2="36.7998"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.1" stop-color="#EFF2F4" />
      <stop offset="0.33" stop-color="#DDE2E6" />
      <stop offset="0.8" stop-color="#ADBAC2" />
      <stop offset="1" stop-color="#96A7B0" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_13722_43684"
      x1="43.8588"
      y1="36.2642"
      x2="43.8588"
      y2="0.385713"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#1C2F72" />
      <stop offset="0.14" stop-color="#17488A" />
      <stop offset="0.41" stop-color="#0D74B3" />
      <stop offset="0.65" stop-color="#0694D2" />
      <stop offset="0.86" stop-color="#02A8E4" />
      <stop offset="1" stop-color="#00AFEB" />
    </linearGradient>
  </defs>
</svg> `, O = ':host .aileron-inline-loading__container{display:flex;justify-content:center;align-items:center}:host .aileron-inline-loading__label{font-family:AmericanSans Var;font-weight:400;font-variation-settings:"wght" 400;font-size:.875rem;line-height:1.25rem;align-items:center;color:#1b1f23;display:inline-flex;position:relative;vertical-align:middle;white-space:nowrap;outline-width:0px}:host .aileron-inline-loading__icon{display:inline-flex;margin-right:4px}:host .aileron-loading__container{align-items:center;text-align:center}:host .aileron-loading__icon-container{display:flex;justify-content:center}:host .aileron-loading__label{font-family:AmericanSans Var;font-weight:400;font-variation-settings:"wght" 400;font-size:1rem;line-height:1.5rem;align-items:center;color:#1b1f23;display:inline-flex;position:relative;vertical-align:middle;white-space:nowrap;margin:16px;outline-width:0px}:host .aileron-loading__icon{display:inline-flex}:host([state=active]) .aileron-loading__icon{color:#006dc0}:host([state=success]) .aileron-inline-loading__icon,:host([state=success]) .aileron-loading__icon{color:#307844}:host([state=error]) .aileron-inline-loading__icon,:host([state=error]) .aileron-loading__icon{color:#d6001b}@media (prefers-color-scheme: dark){:host([aileron-color-scheme=dark]) .aileron-loading__label{color:#f9fafb}:host([aileron-color-scheme=dark]):host([state=active]) .aileron-loading__icon{color:#3aabff}:host([aileron-color-scheme=dark]):host([state=success]) .aileron-loading__icon{color:#53ba6f}:host([aileron-color-scheme=dark]):host([state=error]) .aileron-loading__icon{color:#ff798a}}:host{align-items:center;background-color:#fffc;display:flex;height:100%;justify-content:center;width:100%;position:absolute;z-index:10}:host(.focus-visible),:host(:focus-within){outline:0px}:host([aileron-color-scheme=dark]){background-color:#131313cc}';
function S(o, t) {
  const i = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (n, e) => {
    const { update: a } = n;
    if (o in n) {
      const s = o;
      n.update = function(l) {
        if (l.has(s)) {
          const b = l.get(s), g = this[s];
          b !== g && (!i.waitUntilFirstUpdate || this.hasUpdated) && this[e](
            b,
            g
          );
        }
        a.call(this, l);
      };
    }
  };
}
var Z = Object.defineProperty, K = Object.getOwnPropertyDescriptor, h = (o, t, i, n) => {
  for (var e = n > 1 ? void 0 : n ? K(t, i) : t, a = o.length - 1, s; a >= 0; a--)
    (s = o[a]) && (e = (n ? s(t, i, e) : s(e)) || e);
  return n && e && Z(t, i, e), e;
};
const m = "aileron-loading", p = {
  root: m,
  container: `${m}__container`,
  label: `${m}__label`,
  iconContainer: `${m}__icon-container`,
  icon: `${m}__icon`
}, it = {
  ACTIVE: "active",
  SUCCESS: "success",
  ERROR: "error",
  NONE: ""
}, E = class E extends D(
  z(x)
) {
  constructor(t) {
    super(), this.hasFocus = !1, this.assistiveText = "Loading", this.state = "", this.labelText = "", this.preventScroll = !1, this.lockPageScrolling = !1, this.customElementString = t;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-loading"), A(
      this.customElementString ? this.customElementString + "-loading" : "adc-loading"
    );
  }
  focus(t) {
    this.textNode.focus(t);
  }
  blur() {
    this.blur();
  }
  handleBlur() {
    this.hasFocus = !1, _(this, "adc-blur");
  }
  handleFocus() {
    this.hasFocus = !0, _(this, "adc-focus");
  }
  firstUpdated() {
    this.focus({ preventScroll: this.preventScroll }), this.parentElement && (this.parentElement.style.position = "relative");
  }
  renderLoadingIcon() {
    return this.state === "active" ? c` <div class="${p.icon}">
        <${this.createTagName(
      "-loading-icon"
    )} icon="action:loader" size="32"></${this.createTagName(
      "-loading-icon"
    )}>
      </div>` : this.state === "success" ? c`
        <div class="${p.icon}">
          <${this.createTagName(
      "-loading-icon"
    )} icon="signal:checkmark" outlined size="32"></${this.createTagName(
      "-loading-icon"
    )}>
        </div>
      ` : this.state === "error" ? c`
        <div class="${p.icon}">
          <${this.createTagName(
      "-loading-icon"
    )} icon="signal:error" outlined size="32"></${this.createTagName(
      "-loading-icon"
    )}>
        </div>
      ` : c``;
  }
  renderLoadingLogo() {
    return H;
  }
  createTagName(t) {
    return T(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  async handleStateChange() {
    await this.textNode, setTimeout(() => {
      this.textNode && this.textNode.setAttribute("aria-label", this.getAriaLabel());
    }, 50);
  }
  getAriaLabel() {
    switch (this.state) {
      case "active":
        return "Loading...";
      case "success":
        return "Load successful";
      case "error":
        return "Load failed";
      default:
        return this.assistiveText;
    }
  }
  handleIsLoadingChanged() {
    this.lockPageScrolling ? (document.documentElement.style.margin = "0", document.documentElement.style.height = "100%", document.documentElement.style.overflow = "hidden") : this.removeLockScrollingStyles();
  }
  render() {
    return c`
      <div class="${p.container}">
        <div class="${p.iconContainer}">
          ${this.renderLoadingLogo()}
        </div>
        <span
          id="loadingLabel"
          aria-live="assertive"
          class="${p.label} "
          tabindex="-1"
          @focus=${this.handleFocus}
          @blur=${this.handleBlur}
          >${this.labelText}</span
        >
        <div class="mb-4">${this.renderLoadingIcon()}</div>
      </div>
    `;
  }
  removeLockScrollingStyles() {
    document.documentElement.style.margin = null, document.documentElement.style.height = null, document.documentElement.style.overflow = null;
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeLockScrollingStyles();
  }
};
E.styles = [x.styles || [], k(O)];
let r = E;
h([
  N()
], r.prototype, "hasFocus", 2);
h([
  F("#loadingLabel")
], r.prototype, "textNode", 2);
h([
  u({ attribute: "assistive-text" })
], r.prototype, "assistiveText", 2);
h([
  u()
], r.prototype, "state", 2);
h([
  u({ attribute: "label-text" })
], r.prototype, "labelText", 2);
h([
  u({ type: Boolean, reflect: !0, attribute: "prevent-scroll" })
], r.prototype, "preventScroll", 2);
h([
  u({ type: Boolean, reflect: !0, attribute: "lock-page-scrolling" })
], r.prototype, "lockPageScrolling", 2);
h([
  S("state")
], r.prototype, "handleStateChange", 1);
h([
  S("lockPageScrolling")
], r.prototype, "handleIsLoadingChanged", 1);
try {
  customElements.define("adc-loading", r), console.warn("@aileron/loading is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/loading");
} catch {
}
function J(o) {
  try {
    customElements.define(
      `${o}-loading`,
      class extends r {
        constructor() {
          super(o);
        }
      }
    );
  } catch {
  }
}
var Q = Object.defineProperty, W = Object.getOwnPropertyDescriptor, f = (o, t, i, n) => {
  for (var e = n > 1 ? void 0 : n ? W(t, i) : t, a = o.length - 1, s; a >= 0; a--)
    (s = o[a]) && (e = (n ? s(t, i, e) : s(e)) || e);
  return n && e && Q(t, i, e), e;
};
const y = "aileron-inline-loading", w = {
  root: y,
  container: `${y}__container`,
  label: `${y}__label`,
  icon: `${y}__icon`
}, C = class C extends D(
  z(x)
) {
  constructor(t) {
    super(), this.hasFocus = !1, this.assistiveText = "Loading", this.state = "", this.labelText = "", this.customElementString = t;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-inline-loading"), A(
      this.customElementString ? this.customElementString + "-inline-loading" : "adc-inline-loading"
    );
  }
  focus(t) {
    this.textNode.focus(t);
  }
  blur() {
    this.blur();
  }
  handleBlur() {
    this.hasFocus = !1, _(this, "adc-blur");
  }
  handleFocus() {
    this.hasFocus = !0, _(this, "adc-focus");
  }
  firstUpdated() {
    this.focus();
  }
  renderLoadingIcon() {
    return this.state === "active" ? c`
        <div class="${w.icon}">
          <${this.createTagName(
      "-inline-loading-icon"
    )} icon="action:loader"></${this.createTagName(
      "-inline-loading-icon"
    )}>
        </div>
      ` : this.state === "success" ? c`
        <div class="${w.icon}">
            <${this.createTagName(
      "-inline-loading-icon"
    )} icon="signal:checkmark" outlined></${this.createTagName(
      "-inline-loading-icon"
    )}>
        </div>
      ` : this.state === "error" ? c`
        <div class="${w.icon}">
          
            <${this.createTagName(
      "-inline-loading-icon"
    )} icon="signal:error" outlined></${this.createTagName(
      "-inline-loading-icon"
    )}>
        </div>
      ` : c``;
  }
  createTagName(t) {
    return T(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  async handleStateChange() {
    await this.textNode, setTimeout(() => {
      this.textNode && this.textNode.setAttribute("aria-label", this.getAriaLabel());
    }, 50);
  }
  getAriaLabel() {
    switch (this.state) {
      case "active":
        return "loading...";
      case "success":
        return "Load successful";
      case "error":
        return "Load failed";
      default:
        return this.assistiveText;
    }
  }
  render() {
    return c`
      <div class="${w.container}">
        <!-- Div is needed for the mac screen reader to work -->
        ${this.renderLoadingIcon()}
        <span
          id="inlineLoadingLabel"
          aria-live="assertive"
          class="${w.label}"
          tabindex="-1"
          @focus=${this.handleFocus}
          @blur=${this.handleBlur}
          >${this.labelText}</span
        >
      </div>
    `;
  }
};
C.styles = [x.styles || [], k(O)];
let d = C;
f([
  N()
], d.prototype, "hasFocus", 2);
f([
  F("#inlineLoadingLabel")
], d.prototype, "textNode", 2);
f([
  u({ attribute: "assistive-text" })
], d.prototype, "assistiveText", 2);
f([
  u()
], d.prototype, "state", 2);
f([
  u({ attribute: "label-text" })
], d.prototype, "labelText", 2);
f([
  S("state")
], d.prototype, "handleStateChange", 1);
try {
  customElements.define("adc-inline-loading", d), console.warn(
    "@aileron/loading is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/loading"
  );
} catch {
}
function X(o) {
  try {
    customElements.define(
      `${o}-inline-loading`,
      class extends d {
        constructor() {
          super(o);
        }
      }
    );
  } catch {
  }
}
function nt(o) {
  try {
    X(o), J(o);
  } catch {
  }
}
export {
  d as InlineLoading,
  it as LOADING_STATE,
  r as Loading,
  nt as registerComponent,
  X as registerInlineLoading,
  J as registerLoading
};
